module.exports = __webpack_public_path__ + "img/image_10.79b32855.jpg";